'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Search = require('../Search');

var _Search2 = _interopRequireDefault(_Search);

var _Map = require('../Map');

var _Map2 = _interopRequireDefault(_Map);

var _List = require('../List');

var _List2 = _interopRequireDefault(_List);

var _Base = require('../Base');

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DesktopPickupLocator = (_temp = _class = function (_BasePickupLocator) {
  (0, _inherits3.default)(DesktopPickupLocator, _BasePickupLocator);

  function DesktopPickupLocator() {
    (0, _classCallCheck3.default)(this, DesktopPickupLocator);
    return (0, _possibleConstructorReturn3.default)(this, (DesktopPickupLocator.__proto__ || (0, _getPrototypeOf2.default)(DesktopPickupLocator)).apply(this, arguments));
  }

  (0, _createClass3.default)(DesktopPickupLocator, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { styleName: 'overlay', onClick: this.props.close }),
        _react2.default.createElement(
          'div',
          { styleName: 'container' },
          _react2.default.createElement(
            'div',
            { styleName: 'header' },
            _react2.default.createElement(
              'div',
              { styleName: 'text' },
              'Choose Collection Point'
            ),
            _react2.default.createElement(
              'div',
              { onClick: this.props.close, styleName: 'closeButton' },
              _react2.default.createElement(_Icon2.default, { type: 'cross' })
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'twoColumns' },
            _react2.default.createElement(
              'div',
              { styleName: 'desktopLeftColumn' },
              _react2.default.createElement(
                'div',
                { styleName: 'search' },
                _react2.default.createElement(_Search2.default, {
                  term: this.props.initialTerm,
                  search: this.props.search,
                  gps: this.props.gps,
                  gpsUnavailable: this.props.gpsUnavailable,
                  canUseGps: this.props.canUseGps
                })
              ),
              _react2.default.createElement(_List2.default, {
                selectLocation: this.props.selectLocation,
                locations: this.getLocations(),
                confirm: this.props.confirm,
                close: this.props.close,
                fetching: this.props.fetchingPickupLocations
              }),
              !this.state.showMore && this.renderShowMore()
            ),
            _react2.default.createElement(_Map2.default, {
              selectLocation: this.props.selectLocation,
              initialTerm: this.props.initialTerm,
              locations: this.getLocations(),
              confirm: this.props.confirm,
              close: this.props.close,
              fetching: this.props.fetchingPickupLocations
            })
          )
        )
      );
    }
  }]);
  return DesktopPickupLocator;
}(_Base2.default), _class.propTypes = {
  search: _react.PropTypes.func,
  close: _react.PropTypes.func,
  gps: _react.PropTypes.bool,
  initialTerm: _react.PropTypes.string,
  pickupLocations: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    name: _react.PropTypes.string,
    lat: _react.PropTypes.number,
    lng: _react.PropTypes.number,
    address: _react.PropTypes.string,
    postcode: _react.PropTypes.string,
    distance_in_miles: _react.PropTypes.string,
    opening_hours: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      day: _react.PropTypes.string,
      hours: _react.PropTypes.string
    }))
  }))
}, _temp);
exports.default = DesktopPickupLocator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/Desktop/index.js
// module id = 2493
// module chunks = 0